const getTagColor = (name) => {
  switch (name) {
    case "Integral":
      return {
        textColor: "#FFFFFF",
        backgroundColor: "#5451fb",
        fontWeight: "400",
      };
    case "Paga Metade":
      return {
        textColor: "#FFFFFF",
        backgroundColor: "#EB7831",
        fontWeight: "400",
      };
    case "Paga Reduzida":
      return {
        textColor: "#000000",
        backgroundColor: "#F6DD64",
        fontWeight: "500",
      };
    default:
      return {
        textColor: "#FFFFFF",
        backgroundColor: "#474747",
        fontWeight: "400",
      };
  }
};

const getCardText = (name) => {
  switch (name) {
    case "Integral":
      return "Você paga o <b>valor total</b> da parcela durante o contrato do seu consórcio e aproveita as vantagens da menor taxa do mercado.";
    case "Paga Metade":
      return "Você paga <b>apenas 50% do valor da parcela até contemplar.</b> Depois, o valor que foi reduzido será diluído e somado nas parcelas restantes.";
    case "Paga Reduzida":
      return "Você tem a parcela <b>reduzida em 30% até contemplar.</b> Depois, a diferença será diluída nas parcelas restantes.";
    default:
      return "Você paga o valor total da parcela durante o contrato do seu consórcio e aproveita as vantagens da menor taxa do mercado.";
  }
};

const getTagText = (name) => {
  switch (name) {
    case "Integral":
      return "Integral";
    case "Paga Metade":
      return "Paga Metade";
    case "Paga Reduzida":
      return "Parcela reduzida em 30%";
    default:
      return "Integral";
  }
};

export { getCardText, getTagColor, getTagText };
